import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { Document } from '@/types'

@Component
export default class DocumentEmailComponent extends Vue {
  emails: String[] = []

  @Prop()
  document!: Document

  @Emit('onSendEmail')
  onSendEmail () {
    const data = {
      voucherType: this.document.voucherType,
      voucherSerie: this.document.serieNumber,
      voucherNumber: this.document.documentNumber,
      to: this.emails
    }

    this.emails = []

    return data
  }
}
